import { TranslateService } from "@ngx-translate/core";
import { StatusMappingManagementPermissions } from "../../permissions";
import { UserContext } from "../../../../../common";
import { MenuItem } from "../../../../../views/layout/sidebar/menu.model";

export const getStatusMappingManagementMenu: (
  userContext?: UserContext,
  translate?: TranslateService
) => MenuItem[] = (userContext?: UserContext, translate?: TranslateService) => {
  const hasAccessToStatusMappingManagement =
      userContext?.hasPermission(StatusMappingManagementPermissions.StatusMapping.ReadAll);
  return [
    {
      id: 14,
      label: translate ? translate.instant('MENUS.STATUS_MAPPING') : 'Status Mapping',
      isHidden: !hasAccessToStatusMappingManagement,
      icon: 'pi pi-map',
      expanded: true,
      link: `configurations/status-mapping`,
    }
  ];
};
